import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { LocalStorageKeys, MenuFuncionCodes } from '../../../../src/app/shared/model';
import { MenuFuncionService } from '../../../../src/app/shared/services';
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  tenantId: number | null = null;;
  tries: number = 0;

  canViewComunidadSeguros: boolean = false;
  canViewPedidosVencimientos: boolean = false;
  canViewIncidenciasVencimientos: boolean = false;
  canViewPedidosVencimientosTipoMaterial: boolean = false;
  canViewPedidosEstados: boolean = false;
  canViewComunidades: boolean = false;
  canViewGastosServicios: boolean = false;
  canViewGastosTiposGasto: boolean = false;
  canViewGastosRankingServicios: boolean = false;
  canViewGastosRankingTiposGasto: boolean = false;
  canViewExpensaUf: boolean = false;
  canViewMisPagos: boolean = false;
  canViewMisGastosUf: boolean = false;
  canViewMovimientosTiposMovimiento: boolean = false;
  canViewResumenCaja: boolean = false;
  canViewResumenSaldo: boolean = false;
  canViewPublicaciones: boolean = true;
  canViewTab1: boolean;
  canViewTab2: boolean;

  constructor(
    private sharedFunctions: SharedFunctions,
    private menuService: MenuFuncionService
  ) {

  }

  ngOnInit() {
    this.loadView();
  }

  loadView() {
    this.tries++;
    this.tenantId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId);

    if (this.tenantId != null && this.tenantId > 0) {
      this.menuService.checkMenuPadre(MenuFuncionCodes.DASHBOARDS).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
          this.canViewComunidadSeguros = data.Result.some(x => x == MenuFuncionCodes.DASHBOARD_SEGUROS_VENCIMIENTO);
          this.canViewPedidosVencimientos = data.Result.some(x => x == MenuFuncionCodes.DASHBOARD_PEDIDOS_VENCIMIENTO);
          this.canViewPedidosEstados = data.Result.some(x => x == MenuFuncionCodes.DASHBOARD_PEDIDOS_ESTADOS);
          this.canViewComunidades = data.Result.some(x => x == MenuFuncionCodes.DASHBOARD_COMUNIDAD_HOME);
          this.canViewIncidenciasVencimientos = data.Result.some(x => x == MenuFuncionCodes.DASHBOARD_INCIDENCIAS_VENCIMIENTO);
          this.canViewGastosServicios = data.Result.some(x => x == MenuFuncionCodes.DASHBOARD_GASTOS_SERVICIO);
          this.canViewGastosTiposGasto = data.Result.some(x => x == MenuFuncionCodes.DASHBOARD_GASTOS_TIPO_GASTO);
          this.canViewGastosRankingServicios = data.Result.some(x => x == MenuFuncionCodes.DASHBOARD_GASTOS_RANKING_SERVICIO);
          this.canViewGastosRankingTiposGasto = data.Result.some(x => x == MenuFuncionCodes.DASHBOARD_GASTOS_RANKING_TIPO_GASTO);
          this.canViewPedidosVencimientosTipoMaterial = data.Result.some(x => x == MenuFuncionCodes.DASHBOARD_PEDIDOS_VENCIMIENTO_TIPO_MATERIAL);
          this.canViewExpensaUf = data.Result.some(x => x == MenuFuncionCodes.DASHBOARD_EXPENSA_UF);
          this.canViewMisPagos = data.Result.some(x => x == MenuFuncionCodes.DASHBOARD_MIS_MOVIMIENTOS_PAGOS);
          this.canViewMisGastosUf = data.Result.some(x => x == MenuFuncionCodes.DASHBOARD_MIS_GASTOS_UF);
          this.canViewMovimientosTiposMovimiento = data.Result.some(x => x == MenuFuncionCodes.DASHBOARD_MOVIMIENTOS_TIPO_MOVIMIENTO);
          this.canViewResumenCaja = data.Result.some(x => x == MenuFuncionCodes.DASHBOARD_CAJA_CHICA)
          this.canViewResumenSaldo = data.Result.some(x => x == MenuFuncionCodes.DASHBOARD_MI_RESUMEN_SALDO)
          this.canViewPublicaciones = data.Result.some(x => x == MenuFuncionCodes.DASHBOARD_PUBLICACIONES);
          this.canViewTab1 = data?.Result != null && data?.Result.some(x => x != MenuFuncionCodes.DASHBOARD_PUBLICACIONES);
          this.canViewTab2 = data?.Result != null && data?.Result.some(x => x == MenuFuncionCodes.DASHBOARD_PUBLICACIONES);
        }
      },
      (err: HttpErrorResponse) => {
        this.sharedFunctions.handleError(err);
      });
    }
    else {
      if (this.tries <= 5) {
        setTimeout(() => { this.loadView(); }, 500);
      }
    }
  }

  getTraduccion(value: string) {
    return this.sharedFunctions.getNombreMenuTenant(value);
  }
}
